import React, { useState } from 'react';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';
import SortTableAscending from 'src/assets/images/SortTableAscending.svg';
import SortTableDescending from 'src/assets/images/SortTableDescending.svg';
import { useSelector, useDispatch } from 'react-redux';
import { setInventoryItemsDetails } from '../../redux/actions';
import InventoryBodyDesktop from './InventoryBodyDesktop';
import InventoryBodyMobile from './InventoryBodyMobile';
import { useTranslation } from 'react-i18next';
 
import {
    HeaderGridContainer,
    HeaderTextContainer,
    HeaderGridMobileContainer,
    HeaderTextMobileContainer,
    SortIcon,
    InventoryContentWrapper,
} from './InventoryBody.styled';

const InventoryBody = (props) => {
    const dispatch = useDispatch();
    // const [sortOrderName, setSortOrderName] = useState('ASC');
    const { bannerHeight } = useSelector((state) => state.loginReducer);

    const [, setCheckToggle] = useState(false);
    const [qtyValidation, setQtyValidation] = useState(false);
    const [qtyErrorMsg, setQtyErrorMsg] = useState('');
    const [, setInventoryList] = useState([]);
    const [, setCheckedItemsDetails] = useState([]);
    const [checkedItemsDataList, setCheckedItemsDataList] = useState([]);
    const { t } = useTranslation();
    const checkedListValue = useSelector(
        (state) => state.InventoryReturnReducer.checkedItems
    );

    useEffectWithErrorLogging(() => {
        props.setChecked(props.inventoryDetails);
        props.inventoryDetails &&
            props.inventoryDetails.map((product) => {
                product.isChecked = checkedListValue
                    .filter((item) => item.uniqueKey == product.uniqueKey)
                    .map((filteredValue) => filteredValue.isChecked)
                    .toString();
            });
        setInventoryList(props.inventoryDetails);
    }, [props.inventoryDetails, checkedListValue]);

    const handleChange = (e, clrAll) => {
        let itemIndex = '';
        let checkedItems = props.inventoryDetails;
        let checkedItemsList = [...checkedListValue];
        let checkedItemsData = [];
        props.inventoryDetails &&
            props.inventoryDetails.map((user, index) => {
                itemIndex = checkedItemsList.findIndex(
                    (product) => product.uniqueKey == user.uniqueKey
                );
                //setItemData(itemIndex,1);
                setCheckToggle(true);
                if (user.uniqueKey == e.target.value || itemIndex >= 0) {
                    checkedItems[index].isChecked = e.target.checked;
                    const existingItemInStore = itemIndex >= 0 ? checkedItemsList[itemIndex] : null;
                    if (existingItemInStore && existingItemInStore.used) {
                        checkedItems[index].used = existingItemInStore.used;
                    } else if (user.used && user.used > 0) {
                        checkedItems[index].used = user.used;
                    } else if (!checkedItems[index].used || checkedItems[index].used === 0) {
                        checkedItems[index].used = 1;
                    }
                    checkedItems[index].checkedIndex = index;
                    checkedItems[index].inventoryIndex = index;
                    checkedItems[index].flag = false;
                    if (
                        user.uniqueKey == e.target.value &&
                        itemIndex >= 0 &&
                        !e.target.checked
                    ) {
                        delete checkedItemsList.splice(itemIndex, 1);
                    } else if (
                        user.uniqueKey == e.target.value &&
                        e.target.checked
                    ) {
                        checkedItemsList.push({ ...checkedItems[index] });
                        checkedItemsData = [
                            ...checkedItemsDataList,
                            { ...checkedItems[index] },
                        ];
                        setCheckedItemsDataList(checkedItemsData);
                    }
                } else {
                    checkedItems[index].isChecked = false;
                }
            });
        dispatch(setInventoryItemsDetails(checkedItemsList));
        props.setChecked([...checkedItems]);
        setCheckedItemsDetails(checkedItemsData);
        selectedItemsCount(checkedItemsData);
        handleSlectedItems(checkedItemsData);
    };
    const selectedItemsCount = (checkedItems) => {
        const count = checkedItems.reduce((counter, obj) => {
            if (obj && obj.flag === false && obj.isChecked === true)
                counter += 1;
            return counter;
        }, 0);
        props.setItemCheckedCount(count);
    };

    const handleSlectedItems = (checkedItems) => {
        let arr = [];
        let itemsSelected = checkedItems.filter((obj) => {
            return obj.isChecked === true;
        });
        itemsSelected.map((value) => {
            arr[value.checkedIndex] = value;
        });
        props.setFilterCheckedItems(arr);
        props.setItemsVal(arr);
    };

    const setItemData = (index, value) => {
        
        if (props.inventoryDetails && props.inventoryDetails[index]) {
            props.inventoryDetails[index].used = value ? parseInt(value) : 0;
        }
        
        let itemVal = [...checkedListValue];
        if (
            itemVal &&
            // itemVal.hasOwnProperty('used') &&
            // value !== undefined &&
            itemVal.length > 0
        ) {
            itemVal.map((item) => {
                if (item.checkedIndex === index) {
                    item.used = value;
                }
            });
            props.setItemsVal(itemVal);
            dispatch(setInventoryItemsDetails(itemVal));
        }
    };

    const countryISOCode = useSelector((state)=>state.loginReducer.hybrisUserDetails.countryISOCode);

    return (
        <>
            <HeaderGridContainer
                container
                justifyContent={'space-between'}
                direction="row"
            >
                <HeaderTextContainer
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={1}
                    style={{
                        marginRight: '-55px',
                    }}
                >
                    {t('consignmentReturn.inventory.return')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="sort-cfn"
                    item
                    xs={12}
                    sm={3}
                    md={3}
                    lg={4}
                    xl={4}
                    mobile={12}
                    className={'ItemDetailsHeader'}
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        try {
                            props.sortChangeHandler('cfn', props.sortOrder);
                        } catch(error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                  {t('consignmentReturn.inventory.itemDetails')}
                    {props.sortParams === 'cfn' ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setsortOrder('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setsortOrder('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                    {/* <SortIcon>
                        {props.sortOrder === 'ASC' && props.sortParam =='cfn' ? (
                            <img
                                src={SortTableAscending}
                                alt="SortTableAscending"
                                value={props.sortOrder}
                                width="auto"
                                height="auto"
                                onClick={() => {
                                    props.setSortCode('cfn');
                                    props.setsortOrder('DESC');
                                }}
                            ></img>
                        ) : (
                            <img
                                src={SortTableDescending}
                                alt="SortTableDescending"
                                width="auto"
                                height="auto"
                                value={props.sortOrder}
                                onClick={() => {
                                    props.setSortCode('cfn');
                                    props.setsortOrder('ASC');
                                }}
                            ></img>
                        )}
                    </SortIcon> */}
                </HeaderTextContainer>
                {countryISOCode == 'US' && <HeaderTextContainer
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={2}
                    mobile={1}
                    className={'uom-ipad-header'}
                >
                   {t('consignmentReturn.inventory.uom')}
                </HeaderTextContainer>}
                <HeaderTextContainer
                    item
                    xs={2}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={2}
                    style={{ whiteSpace: 'nowrap' }}
                >
                    {t('consignmentReturn.inventory.returnQty')}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="sort-onhand"
                    item
                    xs={1}
                    sm={1}
                    md={1}
                    lg={1}
                    xl={1}
                    mobile={1}
                    className={'nowrap-text-responsive'}
                    style={{
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        try {
                            props.sortChangeHandler('onhand', props.sortOrder);
                        } catch(error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                   {t('consignmentReturn.inventory.onHand')}
                    {props.sortParams === 'onhand' ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setsortOrder('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setsortOrder('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                    {/* <SortIcon>
                        {props.sortOrder === 'ASC' && props.sortParam =='onHand' ? (
                            <img
                                src={SortTableAscending}
                                alt="SortTableAscending"
                                value={props.sortOrder}
                                width="auto"
                                height="auto"
                                onClick={() => {
                                    props.setSortCode('onHand');
                                    props.setsortOrder('DESC');
                                }}
                            ></img>
                        ) : (
                            <img
                                src={SortTableDescending}
                                alt="SortTableDescending"
                                width="auto"
                                height="auto"
                                value={props.sortOrder}
                                onClick={() => {
                                    props.setSortCode('onHand');
                                    props.setsortOrder('ASC');
                                }}
                            ></img>
                        )}
                    </SortIcon> */}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="sort-batch"
                    item
                    xs={12}
                    sm={1}
                    md={1}
                    lg={2}
                    xl={2}
                    mobile={12}
                    style={{
                        paddingLeft: '30px',
                        whiteSpace: 'nowrap',
                        cursor: 'pointer',
                    }}
                    onClick={() => {
                        try {
                            props.sortChangeHandler('batch', props.sortOrder);
                        } catch(error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                  {t('consignmentReturn.inventory.lotorserial')}
                    {props.sortParams === 'batch' ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setsortOrder('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setsortOrder('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                    {/* <SortIcon>
                        {props.sortOrder === 'ASC' && props.sortParam =='batch'? (
                            <img
                                src={SortTableAscending}
                                alt="SortTableAscending"
                                value={props.sortOrder}
                                width="auto"
                                height="auto"
                                onClick={() => {
                                    props.setSortCode('batch');
                                    props.setsortOrder('DESC');
                                }}
                            ></img>
                        ) : (
                            <img
                                src={SortTableDescending}
                                alt="SortTableDescending"
                                width="auto"    
                                height="auto"
                                value={props.sortOrder}
                                onClick={() => {
                                    props.setSortCode('batch');
                                    props.setsortOrder('ASC');
                                }}
                            ></img>
                        )}
                    </SortIcon> */}
                </HeaderTextContainer>
                <HeaderTextContainer
                    id="sort-usebydate"
                    item
                    xs={12}
                    sm={2}
                    md={2}
                    lg={1}
                    xl={1}
                    mobile={12}
                    align={'right'}
                    style={{
                        alignText: 'right',
                        cursor: 'pointer',
                    }}
                    className={'text-align-right'}
                    onClick={() => {
                        try {
                            props.sortChangeHandler('usebydate', props.sortOrder);
                        } catch(error) {
                            logErrorToConsole(error);
                        }
                    }}
                >
                   {t('consignmentReturn.inventory.useBy')}
                    {props.sortParams === 'usebydate' ? (
                        <SortIcon>
                            {props.sortOrder === 'ASC' ? (
                                <img
                                    src={SortTableAscending}
                                    alt="SortTableAscending"
                                    value={props.sortOrder}
                                    width="auto"
                                    height="auto"
                                    // onClick={() => {
                                    //     props.setsortOrder('DESC');
                                    // }}
                                ></img>
                            ) : (
                                <img
                                    src={SortTableDescending}
                                    alt="SortTableDescending"
                                    width="auto"
                                    height="auto"
                                    value={props.sortOrder}
                                    // onClick={() => {
                                    //     props.setsortOrder('ASC');
                                    // }}
                                ></img>
                            )}
                        </SortIcon>
                    ) : null}
                    {/* <SortIcon>
                        {props.sortOrder === 'ASC' && props.sortParam =='useByDate'? (
                            <img
                                src={SortTableAscending}
                                alt="SortTableAscending"
                                value={props.sortOrder}
                                width="auto"
                                height="auto"
                                onClick={() => {
                                    props.setSortCode('useByDate');
                                    props.setsortOrder('DESC');
                                }}
                            ></img>
                        ) : (
                            <img
                                src={SortTableDescending}
                                alt="SortTableDescending"
                                width="auto"
                                height="auto"
                                value={props.sortOrder}
                                onClick={() => {
                                    props.setSortCode('useByDate');
                                    props.setsortOrder('ASC');
                                }}
                            ></img>
                        )}
                    </SortIcon> */}
                </HeaderTextContainer>
            </HeaderGridContainer>

            <HeaderGridMobileContainer
                container
                justifyContent={'space-between'}
                direction="row"
                mbHeaderPadding={' 10px 0px 10px 10px'}
            >
                <HeaderTextMobileContainer
                    item
                    xs={1}
                    sm={1}
                    md={2}
                    lg={2}
                    xl={2}
                    mobile={2}
                >
                    {t('consignmentReturn.inventory.return')}
                </HeaderTextMobileContainer>
                <HeaderTextMobileContainer
                    item
                    xs={7}
                    sm={7}
                    md={7}
                    lg={7}
                    xl={7}
                    mobile={7}
                >
                   {t('consignmentReturn.inventory.itemDetails')}
                </HeaderTextMobileContainer>
                <HeaderTextMobileContainer
                    item
                    xs={3}
                    sm={3}
                    md={3}
                    lg={3}
                    xl={3}
                    mobile={3}
                >
                    <div style={{ marginLeft: '10px' }}>{t('consignmentReturn.inventory.returnQty')}</div>
                </HeaderTextMobileContainer>
            </HeaderGridMobileContainer>
            <InventoryContentWrapper 
                className={'inventory-body-content-wrapper'}
                bannerHeight={bannerHeight}
            >
                {props.inventoryDetails &&
                    props.inventoryDetails.map((user, index) => {
                        return (
                            <>
                                <InventoryBodyDesktop
                                    user={user}
                                    handleChange={handleChange}
                                    //handleQtyValidation={handleQtyValidation}
                                    qtyValidation={qtyValidation}
                                    index={index}
                                    //key={index}
                                    setQtyVal={props.setQtyVal}
                                    setQtyErrorMsg={setQtyErrorMsg}
                                    setQtyValidation={setQtyValidation}
                                    qtyErrorMsg={qtyErrorMsg}
                                    qtyVal={props.qtyVal}
                                    setQuantityValue={(value) => {
                                        props.setInputValue(value);
                                    }}
                                    setItemDetails={(index, value) => {
                                        setItemData(index, value);
                                    }}
                                    setValidation={(value) => {
                                        //props.setValid(value);
                                    }}
                                    clrAll={props.clrAll}
                                />

                                <InventoryBodyMobile
                                    user={user}
                                    handleChange={handleChange}
                                    //handleQtyValidation={handleQtyValidation}
                                    qtyValidation={qtyValidation}
                                    index={index}
                                    key={index}
                                    setQtyVal={props.setQtyVal}
                                    setQtyErrorMsg={setQtyErrorMsg}
                                    setQtyValidation={setQtyValidation}
                                    qtyErrorMsg={qtyErrorMsg}
                                    setQuantityValue={(value) => {
                                        props.setInputValue(value);
                                    }}
                                    setItemDetails={(index, value) => {
                                        setItemData(index, value);
                                    }}
                                    clrAll={props.clrAll}
                                />
                            </>
                        );
                    })}
            </InventoryContentWrapper>
        </>
    );
};

export default InventoryBody;
